import React, { useEffect } from "react";
import PageLoader from "components/PageLoader";
import { useAuth } from "util/auth";
import { useRouter, useLocation } from "util/router";
// import { redirectToBilling } from "./../util/stripe.js";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function Build(props) {
  const router = useRouter();
  const auth = useAuth();

  const path = useQuery().get('path');
  const hash = useQuery().get('hash')

    useEffect(() => {
        if (path && hash) {
            router.push(path + "#" + hash)
        } else if (path) {
            router.push(path)
        } else {
            router.push('dashboard')
        }
        // if (auth?.stripePartner?.planId) {
        //   // If user has a plan then take them to the
        //   // Stripe billing portal to manage it.
        //   redirectToBilling();
        // } else {
        //   // Otherwise go to pricing so they can
        //   // purchase a plan.
        //   router.push("/pricing");
        // }
    }, [path]);

  return (
    <PageLoader
      style={{
        height: "50px",
      }}
    ></PageLoader>
  );
}

export default Build;
